import { zoneActionType } from '../../constants/index';

export default (state = {}, action) => {
    switch (action.type) {
        case zoneActionType.FETCH_ZONES_ALL:
            return {
                ...state,
                "zonesAll": action.payload
            };
        case zoneActionType.FETCH_ZONES_SUCCESS:
            return {
                ...state,
                "zoneAPISuccess": action.payload
            };
        default:
            return state;
    }
};
